<template>
    <div>
        <c-dialog ref="agencyPriceEdit" :title="title" width="1024" @resolve="setPriceHandle">
            <module title="商品规格信息">
                <c-table ref="priceTable" height="500" :paging="false" v-if="isLoadLevel && isLoadLevel > 0">
                    <c-table-column
                            label="规格名称"
                            name="product_sku_spec"
                            width="160"
                    ></c-table-column>

                    <c-table-column
                            label="SKU编码"
                            name="product_sku_code"
                            width="120"
                    ></c-table-column>

                    <c-table-column
                            label="商家报价"
                            name="product_price_cost"
                            width="90"
							v-if="systemConfig.pt_mode == 2"
                    >
                        <template v-slot="{data}">
                            <span>￥{{data.product_price_cost}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="平台加价"
                            width="110"
                            v-if="systemConfig.pt_mode == 2 && platformProfitModel == 2"
                    >
                        <template slot="head">
                            <div class="flex-center-cross">
                                <span>加价金额</span>
                                <a style="margin-left: 10px;" @click="$refs.batchPriceDialog.open()"><i class="tf tf-edit"></i></a>
                            </div>
                        </template>
                        <template v-slot="{data}">
                            <c-input v-model="data.product_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="零售价"
                            name="product_price"
                            width="90"
                    >
                        <template v-slot="{data}">
                            ￥{{(parseFloat(data.product_price_cost) + (parseFloat(data.product_raise_price) || 0)).toFixed(2) }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            v-show="agencyList && agencyList.length > 0"
                            v-for="(item, i) in agencyList"
                            width="100"
                            :label="item.level_name"
                    >
                        <template slot="head">
                            <div class="flex-center-cross">
                                <span>{{item.level_name}}</span>
                                <a style="margin-left: 10px;" @click="batchPriceHy(item)"><i class="tf tf-edit"></i></a>
                            </div>
                        </template>
                        <template v-slot="{data}">
                            <c-input v-model="data['product_price_'+item.level_id]" type="number" decimal="2" :limit="[0.01, data.product_price]"></c-input>
                        </template>
                    </c-table-column>
                </c-table>
            </module>
            <module title="商品定制信息" v-show="isCustom == 1">
                <c-table ref="customTable" height="auto" :paging="false">
                    <c-table-column
                            label="定制项"
                            name="item_name"
                            width="150"
                    >
                        <template v-slot="{data}">
                            {{ data.item_name }}{{ data.param_value ? '【' + data.param_value + '】' : '' }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制位置"
                            name="position_name"
                            width="160"
                    >
                        <template v-slot="{data}">
                            <div v-if="data.position_name" class="flex-center-cross">
                                <c-image :src="data.position_image_url" preview size="30"
                                         style="margin-right: 10px;"></c-image>
                                <span>{{ data.position_name }}</span>
                            </div>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="工艺名称"
                            name="tech_name"
                            width="100"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.tech_name">{{ data.position_name }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="起定量"
                            name="min_custom_count"
                            width="60"
                    ></c-table-column>

                    <c-table-column
                            label="商家定制价"
                            name="product_price_cost"
                            width="80"
                    >
                        <template v-slot="{data}">
                            ￥{{ data.product_price_cost }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="平台加价"
                            width="100"
                            v-if="this.platformProfitModel == 2"
                    >
                        <template slot="head">
                            <div class="flex-center-cross">
                                <span>定制加价</span>
                                <a style="margin-left: 10px;" @click="$refs.batchCustomPriceDialog.open()"><i
                                        class="tf tf-edit"></i></a>
                            </div>
                        </template>
                        <template v-slot="{data}">
                            <c-input v-model="data.custom_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="平台定制价"
                            name="product_sku_stock"
                            width="100"
                    >
                        <template v-slot="{data}">
                            ￥{{ (parseFloat(data.product_price_cost) + (parseFloat(data.custom_raise_price) || 0)).toFixed(2) }}
                        </template>
                    </c-table-column>
                </c-table>
            </module>
        </c-dialog>

        <!--单商品多SKU-设个各个SKU等级售价-->
        <c-dialog ref="batchPriceHyDialog" :title="batchPriceHyDialogTitle" width="400" height="140" @resolve="batchSetHyPrice">
            <c-form ref="batchPriceHyForm">
                <c-form-item type="number" label="售价" :limit="[0.01,9999]" name="value" decimal="2"></c-form-item>
            </c-form>
        </c-dialog>

        <!--单商品多SKU-->
        <c-dialog ref="batchPriceDialog" title="SKU批量加价" width="400" height="140" @resolve="batchAddProductSKUPrice">
            <c-form ref="batchPriceForm">
                <c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
            </c-form>
        </c-dialog>

        <!--单商品多SKU-->
        <c-dialog ref="batchCustomPriceDialog" title="定制批量加价" width="400" height="140" @resolve="batchAddProductCustomSKUPrice">
            <c-form ref="batchCustomPriceForm">
                <c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
            </c-form>
        </c-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    components: {},

    props: {},

    computed: {
        ...mapState(['dict']),
        ...mapState(['systemConfig'])

    },

    data() {
        return {
            title:'产品代理价格设置',
            productId:0,
            isLoadLevel:0,//是否已加载代理等级
            agencyList:[],
            batchPriceHyDialogTitle:'批量设置售价',
            isCustom:0,//商品是否支持定制 1=支持
            platformProfitModel:0 // 平台盈利模式 1：向商家抽取服务费，2：加价销售
        }
    },

    methods: {
        open(data) {
            this.productId = data.product_id;
            this.isCustom = data.is_custom||0;
            this.platformProfitModel = data.platform_profit_model||0;
            console.log(data.platform_profit_model);
            this.initTableHeader();
            var product_name = data.product_name;
            if (product_name.length > 20){
                product_name = product_name.slice(0, 20)+'...';
            }
            this.title = '产品【'+product_name+'】各SKU售价设置';
        },
        //加载表头数据
        initTableHeader(){
            this.request({
                url: '/user_level/options',
                data: {
                    is_common_user:2
                },
                success: data => {
                    this.agencyList = [];
                    this.isLoadLevel = 1;
                    //系统启用分销，且分销价格体系是按照SKU设置各个等级的价格，则需要按等级配置SKU价格
                    if (this.systemConfig.share_enable=='ON' && this.systemConfig.agency_price_mode == 2){
                        this.agencyList = Array.from(data, item => {
                            return {
                                level_name: item.name,
                                level_id: item.value
                            }
                        });
                    }
                    this.$nextTick(()=>{
                        this.$refs.priceTable.load({
                            url: '/product/sku/price/list',
                            data: {
                                product_id:this.productId
                            }
                        });
                        //定制价格信息
                        if (this.$refs.customTable){
                            this.$refs.customTable.load({
                                url: '/product/custom/info',
                                data: {
                                    product_id: this.productId
                                },
                                dataFormatter: data => {
                                    var tableData = [];
                                    data.forEach(item => {
                                        if (item.list.length != 0) {
                                            tableData = tableData.concat(item.list);
                                        }
                                    });
                                    return tableData;
                                }
                            });
                        }
                        this.$refs.agencyPriceEdit.open();
                    })
                }
            });
        },

        //批量加价(商品金额)
        batchAddProductSKUPrice() {
            let n = parseFloat(this.$refs.batchPriceForm.serialize().value);
            if (n == n) {
                this.$refs.priceTable.getRow().forEach(item => {
                    item.data.product_raise_price = n;
                })
            }
            this.$refs.batchPriceForm.clear();
        },

        //批量加价(定制金额)
        batchAddProductCustomSKUPrice() {
            let n = parseFloat(this.$refs.batchCustomPriceForm.serialize().value);
            if (n == n) {
                this.$refs.customTable.getRow().forEach(item => {
                    item.data.custom_raise_price = n;
                })
            }
            this.$refs.batchCustomPriceForm.clear();
        },

        //批量设置代理价格（弹框）
        batchPriceHy(levelInfo){
            this._batchLevel = levelInfo.level_id;
            this.batchPriceHyDialogTitle = '批量设置【'+levelInfo.level_name+'】售价'
            this.$refs.batchPriceHyDialog.open();
        },

        //批量设置代理价格（设置）
        batchSetHyPrice(){
            let n = parseFloat(this.$refs.batchPriceHyForm.serialize().value);
            if (n) {
                this.$refs.priceTable.getRow().forEach(item => {
                    if(this._batchLevel){
                        item.data['product_price_'+this._batchLevel] = n;
                    }else{
                        item.data.product_price = n;
                    }
                })
            }
            this.$refs.batchPriceHyForm.clear();
        },

        //提交分销价格设置数据
        setPriceHandle(stop) {
            stop();
            var list = this.$refs.priceTable.getRow();
            var falg = true;
            var msg = '';
            list.forEach(item => {
                item.data.product_price = (parseFloat(item.data.product_price_cost) || 0)+(parseFloat(item.data.product_raise_price) || 0);
                /*if (!item.data.product_price) {
                    falg = false;
                    msg = '请填写规格【' + item.data.product_sku_spec + '】的零售价格';
                    return;
                }*/
                this.agencyList.forEach(agencyLevel => {
                    if (!item.data['product_price_'+agencyLevel.level_id]) {
                        falg = false;
                        msg = '请填写规格【' + item.data.product_sku_spec + '】的“'+agencyLevel.level_name+'”价格';
                        return;
                    }
                    if (item.data['product_price_'+agencyLevel.level_id] > item.data.product_price) {
                        falg = false;
                        msg = '规格【' + item.data.product_sku_spec + '】的“'+agencyLevel.level_name+'”价格设置异常，不允许高于零售价格';
                        return;
                    }
                });
            });

            if (!falg) {
                this.$message({
                    text: msg
                });
                return;
            }

            this.request({
                url: '/product/sku/price/edit',
                data: {
                    product_id: this.productId,
                    product_sku_price_list: Array.from(this.$refs.priceTable.getRow(), item => {
                        var resultObj = {};
                        resultObj.product_sku = item.data.product_sku;
                        resultObj.product_sku_spec = item.data.product_sku_spec;
                        resultObj.product_price = parseFloat(item.data.product_price) || 0;
                        this.agencyList.forEach(agencyLevel => {
                            resultObj['product_price_'+agencyLevel.level_id] = item.data['product_price_'+agencyLevel.level_id]
                        });
                        return resultObj;
                    }),
                    product_custom_list: this.isCustom == 1 ? Array.from(this.$refs.customTable.getRow(), item => {
                        item.data.custom_raise_price = parseFloat(item.data.custom_raise_price) || 0
                        return item.data;
                    }) : []
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '商品SKU售价设置成功'
                    });
                    this.$refs.agencyPriceEdit.close();
                    this.$emit('resolve',1);
                }
            });
        },
    }
}
</script>